import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

const API_URL = "/v1/AllotedBooklet"; 

export const submitBooklet = createAsyncThunk(
  "bookletSubmission/submitBooklet",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(API_URL, payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Submission failed"
      );
    }
  }
);

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const bookletSubmissionSlice = createSlice({
  name: "bookletSubmission",
  initialState,
  reducers: {
    resetBookletSubmission: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitBooklet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitBooklet.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitBooklet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBookletSubmission } = bookletSubmissionSlice.actions;

export default bookletSubmissionSlice.reducer;
